const plan: Mapping[] = [
  {
    label: '無料プラン',
    value: 0,
    price: 0,
  },
  {
    label: 'スタンダードプラン',
    value: 1,
    price: 50,
  },
  {
    label: 'エンタープライズプラン',
    value: 2,
    price: 0,
  },
];

export default plan;
